import React, { useRef } from 'react';

export default function Iframe(props) {
    const refIframe = useRef(null);

    if (props.src) {
        const iframeData = `
            <iframe
                title="myBook"
                src=${props.src}
                height=${props.height}
                width=${props.width}
                frameBorder="0"
                scrolling="true"
                allowFullScreen={true}
                ref=${refIframe}
            >
            </iframe>`;
            
        return <div className='iframe-page' dangerouslySetInnerHTML={{ __html: iframeData }}></div>;
    }
    return null;
}
